// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.7 4.65C7.7 6.33 6.33 7.7 4.65 7.7C2.97 7.7 1.6 6.33 1.6 4.65C1.6 2.97 2.97 1.6 4.65 1.6C6.33 1.6 7.7 2.97 7.7 4.65Z',
  'M14.4 11.35C14.4 13.03 13.03 14.4 11.35 14.4C9.67 14.4 8.3 13.03 8.3 11.35C8.3 9.67 9.67 8.3 11.35 8.3C13.03 8.3 14.4 9.67 14.4 11.35Z',
  'M2.49 6.81L6.81 2.49M8.3 11.35H14.4',
];
